import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import { useMemo } from "react";

export function DraggableList<T>({
  list,
  onChange,
  render,
  getId,
}: {
  list: T[];
  onChange: (newList: T[]) => void;
  render: (item: T, i: number, arr: T[]) => React.ReactNode;
  getId: (item: T, i: number) => string;
}) {
  const listOfIds = useMemo(() => list.map(getId), [getId, list]);

  const handleDragEnd = (ev: DragEndEvent) => {
    if (!ev.over) return;
    if (ev.over.id === ev.active.id) return;

    const oldIdx = listOfIds.indexOf(ev.active.id.toString());
    const newIdx = listOfIds.indexOf(ev.over.id.toString());

    onChange(arrayMove(list, oldIdx, newIdx));
  };
  return (
    <DndContext onDragEnd={handleDragEnd}>
      <SortableContext items={listOfIds}>{list.map(render)}</SortableContext>
    </DndContext>
  );
}
